import platform from '../platform';
import { versionCompare } from '../versionCompare';

/** 哈啰出行 app 数科 tabbar 客户端容器 客户端支持版本 ios 6.79.0 以上  android 6.91.0 及以上 */
export default (): boolean => {
  const versionMatch = /version=([\d.]*)/.exec(navigator.userAgent);
  const appVersion = (versionMatch && versionMatch[1]) || '';

  if (platform.isEasyBike || platform.isSkzhenxhApp) {
    return !!(
      (platform.isAndroid && versionCompare(appVersion, '6.91.0') >= 0)
      || (platform.isIOS && versionCompare(appVersion, '6.79.0') >= 0)
      || (platform.isHarmony && false)
    );
  }

  return false;
};
